<!--
 * @Author: yacai 1756496601@qq.com
 * @Date: 2023-10-08 17:23:41
 * @LastEditors: yacai 1756496601@qq.com
 * @LastEditTime: 2023-11-30 14:56:42
 * @FilePath: /fe_bizSubject/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE

-->
<template>
  <div id="app" v-if="show">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "app",
  components: {},
  data () {
    return {
      isScreen: true,
      show: false
    };
  },
  methods: {
    async initConfig () {
      const configUrl = `/fe-config.json?version=${new Date().getTime()}`;
      if (!sessionStorage.getItem("feConfig")) {
        const { data: config } = await axios.request({
          url: configUrl,
          method: "get"
        });
        sessionStorage.setItem("feConfig", JSON.stringify(config));
      }
    }
  },
  created () {
    this.initConfig()
      .then(() => {
        const { apiHost } = JSON.parse(sessionStorage.getItem("feConfig"));
        let url;
        if (apiHost.includes("/api")) {
          url = apiHost;
        } else {
          url = `https://${apiHost}`;
        }
        axios.defaults.baseURL = url;
      })
      .finally(() => {
        this.show = true;
      });
  }
};
</script>
